import React, { useState } from "react";
import "./App.css";
import { Col } from "reactstrap";
import Start from "./components/Start/Start";
import PersonalInformation from "./components/PesonalInformation/PersonalInformation";
import AdjustVolume from "./components/AdjustVolume/AdjustVolume";
import ChooseTest from "./components/ChooseTest/ChooseTest";
import Instructions from "./components/Instructions/Instructions";
import HearingTest from "./components/HearingTestImages/HearingTest";
import tluLogo from "./images/tluLogo.png";
import Alerts from "./components/Alerts/Alerts";
import * as S from "./AppStyle";
import AppContextProvider from "./AppContext";

const App = () => {
  const [currentViewNo, setCurrentViewNo] = useState(0);
  const [showAlert, setShowAlert] = useState(false);
  const [showSuccessAlert, setShowSuccessAlert] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  const views = [
    <Start onForwardBtnClick={onForwardBtnClick} />,
    <PersonalInformation
      onBackBtnClick={onBackBtnClick}
      onForwardBtnClick={onForwardBtnClick}
      updateErrorMessage={updateErrorMessage}
    />,
    <ChooseTest
      onBackBtnClick={onBackBtnClick}
      onForwardBtnClick={onForwardBtnClick}
    />,
    <AdjustVolume
      onBackBtnClick={onBackBtnClick}
      onForwardBtnClick={onForwardBtnClick}
    />,
    <Instructions
      onBackBtnClick={onBackBtnClick}
      onForwardBtnClick={onForwardBtnClick}
    />,
    <HearingTest
      onBackBtnClick={onBackBtnClick}
      updateErrorMessage={updateErrorMessage}
      updateSuccessMessage={updateSuccessMessage}
    />,
  ];

  function updateSuccessMessage(message) {
    setShowAlert(false);
    setShowSuccessAlert(true);
    setSuccessMessage(message);
  }

  function updateErrorMessage(message) {
    setShowAlert(true);
    setShowSuccessAlert(false);
    setErrorMessage(message);
  }

  function onForwardBtnClick() {
    setCurrentViewNo(currentViewNo + 1);
    onAlertDismiss();
  }

  function onBackBtnClick() {
    setCurrentViewNo(currentViewNo - 1);
    onAlertDismiss();
  }

  function onAlertDismiss() {
    setShowAlert(false);
    setShowSuccessAlert(false);
  }

  return (
    <AppContextProvider>
      <S.BootstrapContainer>
        <S.BootstrapRow>
          <Col xs="9">
            <Alerts
              showAlert={showAlert}
              showSuccessAlert={showSuccessAlert}
              errorMessage={errorMessage}
              successMessage={successMessage}
              onAlertDismiss={onAlertDismiss}
            />
          </Col>
          <Col xs="3">
            <img id="logo" src={tluLogo} alt="logo" />
          </Col>
        </S.BootstrapRow>

        <S.BootstrapBodyRow>{views[currentViewNo]}</S.BootstrapBodyRow>
      </S.BootstrapContainer>
    </AppContextProvider>
  );
};

export default App;
